import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button, Card, Checkbox, DatePicker, Form, Input, InputNumber, Modal, Radio, Space, Table, Tag } from 'antd';
import type { DatePickerProps, RadioChangeEvent, TableColumnsType } from 'antd';
import { CustomAxios } from "../../services/api";
import type { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { FilterValue, SorterResult } from "antd/es/table/interface";
import { ClubInfosType, MemberListType, TableColumnType, memberListArray } from './common.type';
import {
    ImportOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
import moment from "moment";
import MessagePopUp from './message.modal';
import ChattingMessagePopUp from './Chattingmessage.moda';

import TagPopUp from './tag.modal';
import { useParams } from 'react-router-dom';
import MessageAllPopUp from './message.all';
import TagSearchPopUp from './tag.search.modal';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { API_BASE_URL } from "../../services/apiConfig";
import ReservationManagementPage from './minihome/ReservationManagementPage';
interface TableParams {
    pagination?: TablePaginationConfig;
    sortField?: string;
    sortOrder?: string;
    filters?: Record<string, FilterValue>;
}

export default function MemberList({ clubSeq, agentSeq, memberid }: { clubSeq: number; agentSeq: number; memberid: any; }) {





    
    const handleModalCancel = () => {
        setModalVisible(false);
    };
    useEffect(() => {
        // console.log("agentSeq", agentSeq);
        // console.log("clubSeq", clubSeq);
        // console.log("memberid", memberid);
    }, [agentSeq, clubSeq, memberid]);

    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisible1, setModalVisible1] = useState(false);
    useEffect(() => {
        if(modalVisible){
            setModalVisible1(!modalVisible1)
        }
    }, [modalVisible]);
    // useEffect(() => {
    //     console.log("소켓실행")
    //     const newSocket = new SockJS(API_BASE_URL + "/ws");
    //     const newStomp = Stomp.over(newSocket);
    //     console.log("API_BASE_URL : " + API_BASE_URL );
    //     const headers = { 'sender': "ID202402211254371004" };

    //     const routingKey = "207@ID202402211254371004@ID202403251434061004"
    //     console.log("채팅방 : " + routingKey );
    //     newStomp.connect(headers, (frame:any) => {
    //       console.log('Socket 연결완료');
    //       // setStompClient(newStomp);
    //       newStomp.subscribe('/queue/subscribe-message/' + routingKey, (message:any) => {
    //         console.log("업데이트!")
    //     //     // fetchissuerMessageUpdate()
    //       });
    //     }, (error:any) => {
    //       console.error('Socket connection error:', error);
    //     });

    // }, []);

    // Rest of your component logic here

    // Rest of your component logic here


    //const lastConsonants = ["ㄱ", "ㄲ", "ㄴ", "ㄷ", "ㄸ", "ㄹ", "ㅁ", "ㅂ", "ㅃ", "ㅅ", "ㅆ", "ㅇ", "ㅈ", "ㅉ", "ㅊ", "ㅋ", "ㅌ", "ㅍ", "ㅎ"];

    // 전체메시지사용자 
    const [memberIdAllAry, setMemberIdAllAry] = useState<string[]>([]);
    const [memberIdSearchAry, setMemberIdSearchAry] = useState<string[]>([]);
    const [memberIdSelectedAry, setMemberIdSelectedAry] = useState<string[]>([]);

    // 테이블 페이징파라미터 
    const [tableParams, setTableParams] = useState<TableParams>({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [total, setTotal] = useState(0);
    //const today = moment();
    const today = moment().format("YYYY-MM-DD");
    var date = new Date();
    const [memberAry, setMemberAry] = useState<memberListArray[]>([]);
    const [columnData, setColumnData] = useState<TableColumnType[]>([]);

    // 테이블 선택 
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalSelected, setTotalSelected] = useState(0);

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);

        // 선택된 항목의 memberId 추출
        const selectedMembers = newSelectedRowKeys.map((item, i) => {
            const members = memberAry[Number(item)].filterMemberCompositeKey.memberId;
            // console.log('selectedRowKeys item: ',  members );   
            return members; // 새로운 배열에 members 변수 추가
        });
        setMemberIdSelectedAry(selectedMembers);
        // console.log('Selected memberIds: ', selectedMembers);
        setTotalSelected(selectedMembers.length);


    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;
    // 테이블 선택 

    // ---- 검색어 
    const [searchMemberName, setSearchMemberName] = useState<string>('');

    const [modalTitle, setModalTitle] = useState<any>("1:N 메시지발송");

    const titlehandleInputChange = (event: any) => {
        setModalTitle(event.target.value); // 입력된 값을 modalTitle 상태에 설정
    };


    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchMemberName(e.target.value);
    };

    // 날짜선택 
    const [searchDiagnosisDate, setSearchDiagnosisDate] = useState<string>("");
    const handleDiagnosisDate: DatePickerProps["onChange"] = (date, dateString) => {
        // console.log("handleDiagnosisDate ",dateString); // moment(date).format("YYYY-MM-DD")
        setSearchDiagnosisDate(dateString);
    };
    // 오늘,일주일,한달,6개월 
    const [searchDiagnosisPeirod, setSearchDiagnosisPeirod] = useState<string>("-1");
    const onChangeDate = (e: RadioChangeEvent) => {
        // console.log(`radio checked:${e.target.value}`);
        setSearchDiagnosisPeirod(e.target.value);
    };

    useEffect(() => {
        //console.log("searchDiagnosisDate", searchDiagnosisDate);
        //console.log("searchDiagnosisPeirod", searchDiagnosisPeirod);
    }, [searchDiagnosisDate, searchDiagnosisPeirod]);

    const [searchMobileNumber, setSearchMobileNumber] = useState("");
    const handleMobileNumber = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchMobileNumber(e.target.value);
    };
    const [searchExtraData, setSearchExtraData] = useState("");
    const handleExtraData = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchExtraData(e.target.value);
    };
    const [searchLocalName, setSearchLocalName] = useState("");
    const handleLocalName = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchLocalName(e.target.value);
    };
    // ---- 검색어 

    // 페이지시작 API요청 
    useEffect(() => {
        requestGetClubInfos();
        requestGetMemberList();
    }, [JSON.stringify(tableParams)]);
    // 테이블 페이징변경 
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue>,
        sorter: SorterResult<TableColumnType>
    ) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };


    // 멤버리스트 가져오기 + 검색파라미터 정의 
    const requestGetMemberList = () => {
        // if(searchDiagnosisDate == ""){
        //     setSearchDiagnosisDate(today);
        // }else if(searchDiagnosisDate != ""){
        //     setSearchDiagnosisPeirod("-1");
        // }
        //     console.log( "--------------------------");
        //     console.log( "tagCheckAry ", tagCheckAry );
        //     console.log( "symptomCheckAry ",symptomCheckAry );
        //     console.log( "roomCheckAry ",roomCheckAry );
        //     console.log( "searchDiagnosisDate >>>>> ",searchDiagnosisDate );
        //     console.log( "searchDiagnosisPeirod >>>>> ",searchDiagnosisPeirod );
        //     console.log( "^^^^^^^^^^^^^^^^^^^^^^^^^^");
        //     console.log( "searchSymptom ",searchSymptom );
        //     console.log( "searchChangeRoom ",searchChangeRoom );


        //    // setLoading(true);
        //     console.log("입력값")
        //     console.log(Number(tableParams.pagination?.current) - 1)
        //     console.log(Number(tableParams.pagination?.pageSize))
        //     console.log(searchMemberName)
        //     console.log(searchDiagnosisDate)
        //     console.log(searchMobileNumber)
        //     console.log(searchExtraData)
        //     console.log(Number(clubSeq))
        //     console.log([searchChangeRoom])
        //     console.log([searchSymptom])
        //     console.log(tagCheckAry)
        //     console.log(searchLocalName)
        //     console.log(Number(searchDiagnosisPeirod))

        CustomAxios.getMemberList({
            page: Number(tableParams.pagination?.current) - 1,
            size: Number(tableParams.pagination?.pageSize),
            memberName: searchMemberName,
            diagnosisDate: searchDiagnosisDate,
            mobileNumber: searchMobileNumber,
            extraData: searchExtraData,
            clubSeq: Number(clubSeq),
            room: [searchChangeRoom],
            symptom: [searchSymptom],
            memoData: tagCheckAry,
            localName: searchLocalName,
            searchDiagnosisPeirod: Number(searchDiagnosisPeirod),
        }).then(
            (response) => {
                const memberLists: MemberListType = response.data;
                // console.log("memberLists",memberLists);

                // ---------초기화 
                // setTagCheckAry([]);
                // setSymptomCheckAry([]);
                // setRoomCheckAry([]);

                setTotal(memberLists.filterMemberList.totalElements);
                setMemberIdSearchAry(memberLists.filteredMemberIdList);
                // console.log("total >>> : " , memberLists.filterMemberList.totalElements);
                setMemberAry(() => memberLists.filterMemberList.content);
                setLoading(false);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: memberLists.filterMemberList.totalElements,
                    },
                });
            },
            (error) => {
            }
        );
    };
    // 테이블 자료구조 
    useEffect(() => {
        const columnData = memberAry?.map((item, i) => ({
            key: i,
            clubSeq: item.filterMemberCompositeKey.clubSeq,
            memberName: item.memberName,
            updated: item.updated,
            mobileNumber: item.mobileNumber,
            memberGrade: item.memberGrade,
            memberDataJson: item.memberDataJson,
            birth: moment(item.birth).format('YYYY-MM-DD'),
            memberId: item.filterMemberCompositeKey.memberId,
            localName: item.localName,
            ageGroup: item.ageGroup,
            questionnaire: item.questionnaire,
            extraData: parseFamilyToString(item.extraData),
            symptom: item.symptom,
            room: item.room,
            memoData: parseMomoData(item.memoData),
            clubMemberSeq: item.clubMemberSeq,
        }));
        setColumnData(() => columnData);
    }, [memberAry]);


    const parseMomoData = (data: string): string => {
        try {
            const parsedData = JSON.parse(data);
            const tags = parsedData["회원태그"]
                .map((item: { [key: string]: boolean }) => Object.keys(item).find(key => item[key]));
            return tags.filter((tag: undefined) => tag !== undefined).join(", ");
        } catch (error) {
            //console.error("JSON 파싱 오류:", error);
            return "";
        }
    };
    interface FamilyMember {
        이름: string;
        관계: string;
    }
    const parseFamilyToString = (jsonData: string): string => {
        try {
            const parsedData: { 가족: { 이름: string; 관계: string }[] } = JSON.parse(jsonData);
            const familyArray: { 이름: string; 관계: string }[] = parsedData.가족;
            const result: string = familyArray.map(member => `${member.이름}(${member.관계})`).join(", ");
            return result;
        } catch (error) {
            //console.error("JSON 파싱 오류:", error);
            return "";
        }
    };
    // 테이블화면구성  
    const columns: ColumnsType<TableColumnType> = [
        { title: "병록번호", dataIndex: "localName" },
        { title: "이름", dataIndex: "memberName" },
        { title: "전화", dataIndex: "mobileNumber" },
        { title: "생년월일", dataIndex: "birth" },
        { title: "연령대", dataIndex: "ageGroup" },
        {
            title: "증상",
            dataIndex: "symptom",
            render: (text, record, index) => (
                <>
                    {text &&
                        text.split(',').filter((item: string) => item.trim() !== '').map((item: string, index: React.Key | null | undefined) => (
                            <Tag key={index} color="green" style={{ textAlign: 'center' }}>{item.trim()}</Tag>
                        ))
                    }
                </>
            ),
        },
        {
            title: "진료실",
            dataIndex: "room",
            render: (text, record, index) => (
                <>
                    {text ? <Tag color="orange" style={{ textAlign: 'center' }}>{text}</Tag> : null}
                </>
            ),
        },
        {
            title: "회원태그",
            dataIndex: "memoData",
            render: (text, record, index) => (
                <>
                    {text &&
                        text.split(',').filter((item: string) => item.trim() !== '').map((item: string, index: React.Key | null | undefined) => (
                            <Tag key={index} color="volcano" style={{ textAlign: 'center' }}>{item.trim()}</Tag>
                        ))
                    }
                </>
            ),

        },
        { title: "가족", dataIndex: "extraData" },
        { title: "접수일", dataIndex: "updated" },
        {
            title: "관리",
            dataIndex: "",
            key: "x",
            render: (text, record, index) => (
                <Space>
                    <Button onClick={(e) => chattingpart(e, record)} icon={<ImportOutlined />}>1:1채팅/태그</Button>
                </Space>
            ),
        },
    ];

    // 검색클릭 
    const requestSubmit = () => {
        requestGetClubInfos();
        requestGetMemberList();
        // console.log( "tagCheckAry ", tagCheckAry );
        // console.log( "symptomCheckAry ",symptomCheckAry );
        // console.log( "roomCheckAry ",roomCheckAry );
    };


    // 태그처리 
    const [tagAry, setTagAry] = useState<string[]>([]);             // 서버에서 가져온것   
    const [tagCheckAry, setTagCheckAry] = useState<string[]>([]);   // 선택된것만 
    const [checkedValues, setCheckedValues] = useState<{ [key: string]: boolean }>({});
    // 증상처리 
    const [symptomAry, setSymptomAry] = useState<string[]>([]);     // 서버에서 가져온것 
    const [symptomCheckAry, setSymptomCheckAry] = useState<string[]>([]);   // 선택된것만 
    const [checkedSymptomValues, setCheckedSymptomValues] = useState<{ [key: string]: boolean }>({});
    // 진료실처리 
    const [roomAry, setRoomAry] = useState<string[]>([]);           // 서버에서 가져온것 
    const [roomCheckAry, setRoomCheckAry] = useState<string[]>([]);   // 선택된것만 
    const [checkedRoomValues, setCheckedRoomValues] = useState<{ [key: string]: boolean }>({});
    // 클럽전체멤버수 
    const [totalMember, setTotalMember] = useState(0);

    const [clubMemberSeqAry, setClubMemberSeqAry] = useState<number[]>([]);           // 서버에서 가져온것 


    // 클럽정보가져오기 
    const requestGetClubInfos = () => {
        // setLoading(true);
        // console.log("확인1")
        // console.log("agentSeq : " + agentSeq)
        // console.log("clubSeq : " + clubSeq)
        CustomAxios.getClubInfos(
            Number(agentSeq),
            Number(clubSeq)
        ).then(
            (response: any) => {
                // console.log("확인2")
                const clubInfos: ClubInfosType = response.data;
                // console.log("clubInfos.memoSetting ",clubInfos.memoSettingTrueList);  
                setTotalMember(clubInfos.clubMemberCount);
                setTagAry(clubInfos.memoSettingTrueList);
                setSymptomAry(clubInfos.symptomTrueList);
                setRoomAry(clubInfos.roomTrueList);
                setMemberIdAllAry(clubInfos.memberIdList);
            },
            (error) => {
                console.log("에러")
            }

        );
    };
    // 태그처리 
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, checked } = event.target;
        // console.log("tag : " , id , checked);
        setCheckedValues(prevState => ({
            ...prevState,
            [id]: checked
        }));
        if (checked) {
            const selectedTag = tagAry[Number(id)];
            // console.log("선택된 태그 값:", selectedTag);
            setTagCheckAry(prevTags => [...prevTags, selectedTag]);
        } else {
            // 선택이 해제된 경우 해당 태그를 배열에서 제거
            setTagCheckAry(prevTags => prevTags.filter(tag => tag !== tagAry[Number(id)]));
        }
    };
    // 증상처리
    const [searchSymptom, setSearchSymptom] = useState("");
    const handleSymptom = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchSymptom(e.target.value);
    };
    // const handleCheckboxChangeSymptom = (event: React.ChangeEvent<HTMLInputElement>) => {        
    //     const { id, checked } = event.target;
    //     console.log("tag : " , id , checked);
    //     setCheckedSymptomValues(prevState => ({
    //         ...prevState,
    //         [id]: checked
    //     }));
    //     if (checked) {
    //         const selectedTag = symptomAry[Number(id)];
    //         console.log("선택된 태그 값:", selectedTag);
    //         setSymptomCheckAry(prevTags => [...prevTags, selectedTag]);
    //     } else {
    //         // 선택이 해제된 경우 해당 태그를 배열에서 제거
    //         setSymptomCheckAry(prevTags => prevTags.filter(tag => tag !== symptomAry[Number(id)]));
    //     }
    // };
    // 진료실처리
    const [searchChangeRoom, setSearchChangeRoom] = useState("");
    const handleChangeRoom = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchChangeRoom(e.target.value);
    };
    // const handleCheckboxChangeRoom = (event: React.ChangeEvent<HTMLInputElement>) => {        
    //     const { id, checked } = event.target;
    //     console.log("tag : " , id , checked);
    //     setCheckedRoomValues(prevState => ({
    //         ...prevState,
    //         [id]: checked
    //     }));
    //     if (checked) {
    //         const selectedTag = roomAry[Number(id)];
    //         console.log("선택된 태그 값:", selectedTag);
    //         setRoomCheckAry(prevTags => [...prevTags, selectedTag]);
    //     } else {
    //         // 선택이 해제된 경우 해당 태그를 배열에서 제거
    //         setRoomCheckAry(prevTags => prevTags.filter(tag => tag !== roomAry[Number(id)]));
    //     }
    // };

    // 모달창     
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [selectedRecord, setSelectedRecord] = useState<TableColumnType>(); // 선택한 레코드 정보를 저장할 상태 변수

    const [chattingIsModalOpen, setchattingIsModalOpen] = useState<boolean>(false);
    const part = (e: any, recode: TableColumnType) => {
        // console.log("part", recode.memberName);   
        setSelectedRecord(recode); // 선택한 레코드 정보 저장
        setIsModalOpen(true); // 모달 열기        
    };
    const chattingpart = (e: any, recode: TableColumnType) => {
        // console.log("part", recode.memberName);   
        // console.log("모달열기")
        setSelectedRecord(recode); // 선택한 레코드 정보 저장
        setchattingIsModalOpen(true); // 모달 열기        
    };
    const handleOk = () => { setIsModalOpen(false); requestSubmit(); };
    const handleCancel = () => { setIsModalOpen(false); requestSubmit(); };


    const chattinghandleOk = () => {
        console.log("모달닫기")
        setchattingIsModalOpen(false); requestSubmit();
    };
    const chattinghandleCancel = () => {
        console.log("모달닫기")
        setchattingIsModalOpen(false); requestSubmit();
    };

    // 모달창2     
    const [isModalOpenTag, setIsModalOpenTag] = useState<boolean>(false);
    const partTag = (e: any) => {
        setIsModalOpenTag(true); // 모달 열기        
    };
    const handleOkTag = () => { setIsModalOpenTag(false); requestSubmit(); };
    const handleCancelTag = () => { setIsModalOpenTag(false); requestSubmit(); };

    // 모달창3     
    const [isModalOpenAll, setIsModalOpenAll] = useState<boolean>(false);
    const [sendType, setSendType] = useState('');
    const partTagAll = (e: any, type: string) => {
        setSendType(type);
        setIsModalOpenAll(true); // 모달 열기        

    };
    const handleOkAll = () => { setIsModalOpenAll(false); requestSubmit(); };
    const handleCancelAll = () => { setIsModalOpenAll(false); requestSubmit(); };

    // 모달창4     
    const [isModalOpenTagSearch, setIsModalOpenTagSearch] = useState<boolean>(false);
    const partTagSearch = (e: any, type: string) => {
        setSendType(type);
        setIsModalOpenTagSearch(true); // 모달 열기        
    };
    const handleOkTagSearch = () => { setIsModalOpenTagSearch(false); requestSubmit(); };
    const handleCancelTagSearch = () => { setIsModalOpenTagSearch(false); requestSubmit(); };
    useEffect(() => {
        //    console.log("chattingIsModalOpen : " + chattingIsModalOpen)
    }, [chattingIsModalOpen]);


    return (
        <div>
            <div style={{ padding: '10px' }}>
                <Card style={{ width: '100%', background: '#f0f2f5' }}>

                    {/* <div style={{ display: 'flex', alignItems: 'center', padding:'3px' }}>
        <Tag color="blue" style={{width:70, textAlign: 'center'}}>이름</Tag>
            {lastConsonants.map((consonant, index) => (
                <Button key={index} type="link" style={{width:20,fontSize: '16px', fontWeight: 'bold', color: 'black'}} block>{consonant}</Button>
            ))}
        </div> */}

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>병록번호</Tag>
                            <Input style={{ width: '100%' }} onChange={handleLocalName} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>이름</Tag>
                            <Input style={{ width: '100%' }} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>전화</Tag>
                            <Input style={{ width: '100%' }} onChange={handleMobileNumber} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>접수일</Tag>
                            <Radio.Group onChange={onChangeDate} defaultValue="-1" buttonStyle="solid">
                                <Radio.Button value="-1">선택안함</Radio.Button>
                                <Radio.Button value="0">오늘</Radio.Button>
                                <Radio.Button value="7">일주일</Radio.Button>
                                <Radio.Button value="30">한달</Radio.Button>
                                <Radio.Button value="180">6개월</Radio.Button>
                            </Radio.Group>
                            <DatePicker  clearIcon style={{ width: 150, marginLeft: 10 }} onChange={handleDiagnosisDate} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>증상</Tag>
                            <Input style={{ width: '50%' }} onChange={handleSymptom} />
                            {symptomAry.map((tag, index) => (
                                <div key={index} style={{ paddingLeft: 5, paddingRight: 0, color: 'grey' }}>
                                    <label htmlFor={`tag_${index}`}>[{tag}]</label>
                                </div>
                            ))}
                            {/*           
                    {symptomAry.map((tag, index) => (
                    <div key={index} style={{paddingRight: 10}}>
                        <input type="checkbox" 
                        id={`${index}`} 
                        name={`tag_${index}`} 
                        value={tag} 
                        checked={checkedSymptomValues[`${index}`] || false}
                        onChange={handleCheckboxChangeSymptom}
                        />
                        <label htmlFor={`tag_${index}`}>{tag}</label>
                    </div>
                    ))} */}

                        </div>
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>진료실</Tag>
                            <Input style={{ width: '50%' }} onChange={handleChangeRoom} />
                            {roomAry.map((tag, index) => (
                                <div key={index} style={{ paddingLeft: 5, paddingRight: 0, color: 'grey' }}>
                                    <label htmlFor={`tag_${index}`}>[{tag}]</label>
                                </div>
                            ))}
                            {/* {roomAry.map((tag, index) => (
                    <div key={index} style={{paddingRight: 10}}>
                        <input type="checkbox" 
                        id={`${index}`} 
                        name={`tag_${index}`} 
                        value={tag} 
                        checked={checkedRoomValues[`${index}`] || false}
                        onChange={handleCheckboxChangeRoom}
                        />                   
                        <label htmlFor={`tag_${index}`}>{tag}</label> 
                    </div>
                    ))} */}
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>가족</Tag>
                            <Input style={{ width: '100%' }} onChange={handleExtraData} />
                        </div>
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="blue" style={{ width: 70, textAlign: 'center' }}>회원태그</Tag>
                            {tagAry.map((tag, index) => (
                                <div key={index} style={{ paddingRight: 10 }}>
                                    <input type="checkbox"
                                        id={`${index}`}
                                        name={`tag_${index}`}
                                        value={tag}
                                        checked={checkedValues[`${index}`] || false}
                                        onChange={handleCheckboxChange}
                                    />
                                    <label htmlFor={`tag_${index}`}>{tag}</label>
                                </div>
                            ))}
                            <Button danger icon={<ImportOutlined />} onClick={(e) => partTag(e)} size="small">태그관리</Button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Button type="primary" style={{ width: '100%' }} icon={<SearchOutlined />} onClick={requestSubmit}>Search</Button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="purple" style={{ width: 100, textAlign: 'center', marginLeft: 0 }}>검색 : {total}명</Tag>
                            <Button danger icon={<ImportOutlined />} onClick={(e) => partTagAll(e, 'search')} size="small" style={{ marginLeft: 10 }}>검색한 {total}명에게 발송</Button>
                            <Button icon={<ImportOutlined />} onClick={(e) => partTagSearch(e, 'search')} size="small" style={{ marginLeft: 10 }}>검색한 {total}명에게 태그설정</Button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="purple" style={{ width: 100, textAlign: 'center', marginLeft: 0 }}>선택 : {totalSelected}명</Tag>
                            <Button danger icon={<ImportOutlined />} onClick={(e) => partTagAll(e, 'selected')} size="small" style={{ marginLeft: 10 }}>선택한 {totalSelected}명에게 발송</Button>
                            <Button icon={<ImportOutlined />} onClick={(e) => partTagSearch(e, 'selected')} size="small" style={{ marginLeft: 10 }}>선택한 {totalSelected}명에게 태그설정</Button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
                            <Tag color="purple" style={{ width: 100, textAlign: 'center', marginLeft: 0 }}>전체 : {totalMember}명</Tag>
                            <Button danger icon={<ImportOutlined />} onClick={(e) => partTagAll(e, 'all')} size="small" style={{ marginLeft: 10 }}>전체 &nbsp;&nbsp; {totalMember}명에게 발송</Button>
                            <Button icon={<ImportOutlined />} onClick={(e) => partTagSearch(e, 'all')} size="small" style={{ marginLeft: 10 }}>전체 &nbsp;&nbsp; {totalMember}명에게 태그설정</Button>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <Button type="primary" onClick={() => setModalVisible(true)}>
                            예약된 메시지 관리
                        </Button>
                        <Modal
                            title="예약된 메시지 관리"
                            visible={modalVisible}
                            width={1200}
                            onCancel={handleModalCancel}
                            footer={[
                                <Button key="cancel" onClick={handleModalCancel}>
                                    닫기
                                </Button>,
                            ]}
                        >
                            <ReservationManagementPage clubSeq={clubSeq} memberid={memberid} modalVisible1={modalVisible1} ></ReservationManagementPage>
                        </Modal>
                    </div>


                </Card>

            </div>


            <Table
                rowSelection={rowSelection}
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={columnData}
                style={{ width: "100%", height: "100vh", marginTop: 0 }}
                pagination={tableParams.pagination}
                loading={loading}
                scroll={{ y: 600 }}
                onChange={(val: any, filter: any, sorter: any, extra: any) => {
                    handleTableChange(val, filter, sorter);
                }}
            />
            <Modal title={`메시지:태그  [${selectedRecord?.memberName}:${selectedRecord?.mobileNumber}]`} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={1000}>
                <MessagePopUp selectedRecord={selectedRecord} tagAry={tagAry} agentSeq={agentSeq} clubSeq={clubSeq}></MessagePopUp>
            </Modal>

            <Modal title={`채팅 상대  [${selectedRecord?.memberName}:${selectedRecord?.mobileNumber}]`} open={chattingIsModalOpen} onOk={chattinghandleOk} onCancel={chattinghandleCancel} width={1000}>
                <ChattingMessagePopUp chattingIsModalOpen={chattingIsModalOpen} memberid={memberid} selectedRecord={selectedRecord} tagAry={tagAry} agentSeq={agentSeq} clubSeq={clubSeq}></ChattingMessagePopUp>
            </Modal>




            <Modal title={`태그관리`} open={isModalOpenTag} onOk={handleOkTag} onCancel={handleCancelTag} width={500}>
                <TagPopUp agentSeq={agentSeq} clubSeq={clubSeq}></TagPopUp>
            </Modal>

            <Modal title={"1:N 메시지발송"} open={isModalOpenAll} onOk={handleOkAll} onCancel={handleCancelAll} width={1000} >
                <MessageAllPopUp selectedRecord={selectedRecord} tagAry={tagAry} agentSeq={agentSeq} clubSeq={clubSeq} messagetitle={modalTitle}
                    memberIdAllAry={memberIdAllAry} memberIdSearchAry={memberIdSearchAry} memberIdSelectedAry={memberIdSelectedAry} sendType={sendType} />
            </Modal>

            <Modal title={`회원태그관리`} open={isModalOpenTagSearch} onOk={handleOkTagSearch} onCancel={handleCancelTagSearch} width={600}>
                <TagSearchPopUp selectedRecord={selectedRecord} tagAry={tagAry} agentSeq={agentSeq} clubSeq={clubSeq}
                    memberIdAllAry={memberIdAllAry} memberIdSearchAry={memberIdSearchAry} memberIdSelectedAry={memberIdSelectedAry} sendType={sendType}></TagSearchPopUp>
            </Modal>
        </div>
    );
}


